import {BaseUtils} from "./base.utils";
import {RESTRICTION_TYPES} from "../../enums/e-restrictions";
export class RestrictionUtils extends BaseUtils {
  createRestriction(key: number): IRestriction {
    let r: IRestriction = <IRestriction>{key: key};
    this.initializeParamsImpl(r);
    return r;
  }


  initializeParam(restriction: IRestriction) {
    this.initializeParamsImpl(restriction);
  }


  private initializeParamsImpl(r: IRestriction): void {
    let key: number = r.key;
    console.log(`init ${key}`);

    switch (key) {
      case RESTRICTION_TYPES.COMING_SOON:
        r.value = 1;
        break;

      case RESTRICTION_TYPES.LEVEL_GREATER_THAN_OR_EQUALS:
      case RESTRICTION_TYPES.QUEST_COMPLETE:
      case RESTRICTION_TYPES.MAGIC_LEVEL_GE_THAN:
      case RESTRICTION_TYPES.QUEST_ACTIVE:
      case RESTRICTION_TYPES.SECTOR_OPENED:
      case RESTRICTION_TYPES.TUTOR_CPOINT_GE_THAN:
      case RESTRICTION_TYPES.WAS_OFFLINE_FOR:
      case RESTRICTION_TYPES.LEVEL_LESS_THAN_OR_EQUALS:
      case RESTRICTION_TYPES.LEVEL_EQUALS:
      case RESTRICTION_TYPES.AFTER_LAST_OFFER_DEACTIVATED:
      case RESTRICTION_TYPES.RESOURCE_GOT:
      case RESTRICTION_TYPES.OFFER_WAS_ACTIVATED:
      case RESTRICTION_TYPES.EVENT_EQUALS:
      case RESTRICTION_TYPES.EVENT_COMPLETE:
      case RESTRICTION_TYPES.LIMIT_REACHED:
      case RESTRICTION_TYPES.BUILDING_EXISTS:
      case RESTRICTION_TYPES.LAST_PERIODICAL_REWARD_COLLECTED:
      case RESTRICTION_TYPES.inv_QUEST_COMPLETE:
      case RESTRICTION_TYPES.inv_MAGIC_LEVEL_GE_THAN:
      case RESTRICTION_TYPES.inv_QUEST_ACTIVE:
      case RESTRICTION_TYPES.inv_SECTOR_OPENED:
      case RESTRICTION_TYPES.inv_TUTOR_CPOINT_GE_THAN:
      case RESTRICTION_TYPES.inv_RESOURCE_GOT:
      case RESTRICTION_TYPES.inv_BUILDING_EXISTS:
      case RESTRICTION_TYPES.inv_EVENT_COMPLETE:
      case RESTRICTION_TYPES.inv_LIMIT_REACHED:

        r.value = 0;
        break;

      case RESTRICTION_TYPES.HAS_ITEM:
      case RESTRICTION_TYPES.RESOURCE_AMOUNT_LESS_THAN:
      case RESTRICTION_TYPES.inv_HAS_ITEM:
        r.value = <IResourceAmountParams>{resourceId:0, amount: 0};
        break;

      case RESTRICTION_TYPES.LOT_IN_OFFER_BOUGHT:
      case RESTRICTION_TYPES.inv_LOT_IN_OFFER_BOUGHT:
        console.log(key);
        r.value = <ILotInOfferRestrictionParams> {offerId:0, lotId:0};
        break;

      case RESTRICTION_TYPES.BUILDING_LEVEL:
      case RESTRICTION_TYPES.inv_BUILDING_LEVEL:
      case RESTRICTION_TYPES.BUILDING_LEVEL_PENDING:
        console.log(key);
        r.value = <ILevelRestrictionParams>{level: 0, object: 0}; // TODO: ERROR
        break;

      case RESTRICTION_TYPES.PAY_AVG_MONETARY:
      case RESTRICTION_TYPES.PAY_MONETARY:
      case RESTRICTION_TYPES.PAY_RECENCY:
      case RESTRICTION_TYPES.PAY_FREQUENCY:
        r.value = <IIntervalRestrictionParams>{from:0, to:0};
        break;

      case RESTRICTION_TYPES.AFTER_OFFER_DEACTIVATED:
        r.value = <IIdTimeRestrictionParams>{id:0, time:0};
        break;

      case RESTRICTION_TYPES.LEVEL_EQUALS_ONE_OF:
        r.value = <IArrayOfLevels>{levels:[0, 1]}
        break;

      case RESTRICTION_TYPES.ONE_OF_OFFER_LOTS_BOUGHT:
        r.value = <IArrayOfOfferLots>{offerId: -1, lotsIds:[]}
        break;
    }
  }
}


export interface IRestriction {
  key: number;
  value:  IArrayOfOfferLots|
          IArrayOfLevels|
          IIdTimeRestrictionParams|
          ILevelRestrictionParams|
          IIntervalRestrictionParams|
          IFrequencyRestrictionParams|
          ILotInOfferRestrictionParams|
          ILotInOfferTimeRestrictionParams|
          IResourceAmountParams|
          number;
}

export interface IArrayOfLevels{
  levels:number[];
}

export interface IArrayOfOfferLots{
  offerId:number;
  lotsIds:number[];
}

export interface  ILotInOfferRestrictionParams {
  offerId: number;
  lotId: number;
}

export interface ILotInOfferTimeRestrictionParams extends ILotInOfferRestrictionParams {
  time:Number;
}

export interface ILevelRestrictionParams {
  object:number;
  level:number;
}

export interface IIntervalRestrictionParams {
  from:number;
  to:number;
}

export interface IIdTimeRestrictionParams {
  id:number;
  time:number;
}

export interface IFrequencyRestrictionParams extends IIntervalRestrictionParams{
  period:number;
}

export interface IResourceAmountParams {
  resourceId:number;
  amount:number;
}





// WEBPACK FOOTER //
// /opt/app/develop/src/app/services/factory-service-impl/restriction.utils.ts